import Recommend from './recommend';

export const routes = [
	{
		path: '/recommends',
		exact: true,
		component: Recommend,
		name: 'Recommend',
	}
];

